export default __webpack_public_path__ + "static/20211202_150358-27127c062e665f7b10e8f7366e8e3b91.jpeg";